import CacheItem from '@/libs/com/MetaPattern/Product/IDE/Util/CacheItem';
import { Dictionary } from '@/libs/com/MetaPattern/Product/IDE/Util/Dictionary';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { Commit } from 'vuex';

const state = {
  cacheItems: new Dictionary<string, CacheItem>() // 缓存项
};

const getters = {
  /** 获取缓存，如果不存在或过期，则返回null，否则返回缓存的对象 */
  cacheItem(states: any): any {
    return (key: string) => {
      let result: any = null;
      const items = states.cacheItems as Dictionary<string, CacheItem>;
      if (ValidateHelper.IsNotNullOrEmpty(key)) {
        const item = items.getValue(key);
        if (item !== null && !item.isExpirered()) {
          result = item.value;
        }
      }
      return result;
    };
  }
};

const mutations = {
  /** 加入缓存：已经存在则替换（不管是否过期），不存在则添加 */
  addItem (states: any, params: CacheItem): void {
    const items = states.cacheItems as Dictionary<string, CacheItem>;
    if (ValidateHelper.IsNotNullOrUndefined(params)) {
      if (items.contains(params.key)) {
        const item = items.getValue(params.key);
        items.remove(item.key);
      }
      items.append(params.key, params);
    }
  },
  /** 清空所有过期的缓存项 */
  clearExpirered(states: any) {
    const items = states.cacheItems as Dictionary<string, CacheItem>;
    const removeKeys = new Array<string>();
    items.Entries.forEach(entry => {
      if (entry.value.isExpirered()) {
        removeKeys.push(entry.key);
      }
    });
    removeKeys.forEach(key => {
      items.remove(key);
    });
  }
};

const actions = {
  addItemAction(context: { commit: Commit }, params: CacheItem) {
    context.commit('addItem', params);
  },
  clearExpireredAction(context: { commit: Commit }) {
    context.commit('clearExpirered');
  }
};

export default {
  namespaced: true, // namespaced为false的时候，state,mutations,actions全局可以调用，为true，生成作用域，引用时要声明模块名称
  state,
  getters,
  mutations,
  actions
};
